// extracted by mini-css-extract-plugin
module.exports = {"loader":"PageOverlayLoader_loader__1sPUp","loaderOuter":"PageOverlayLoader_loaderOuter__gC7Z8"};